/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * テキスト配置 (null許容)
 * @export
 */
export const TextAlignmentNullable = {
  Left: 'left',
  Center: 'center',
  Right: 'right'
} as const
export type TextAlignmentNullable = typeof TextAlignmentNullable[keyof typeof TextAlignmentNullable]

export function TextAlignmentNullableFromJSON(json: any): TextAlignmentNullable {
  return TextAlignmentNullableFromJSONTyped(json, false)
}

export function TextAlignmentNullableFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextAlignmentNullable {
  return json as TextAlignmentNullable
}

export function TextAlignmentNullableToJSON(value?: TextAlignmentNullable | null): any {
  return value as any
}
